/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Product-section re-init registry.
 *
 * Any function passed to ProductInit.register(fn) will run:
 *   - once on initial page load
 *   - again after every <variant-picker> HTML swap
 *
 * Write each init as if it were running on a fresh page:
 *   - re-query the DOM every time (don't cache element refs across calls)
 *   - make it idempotent (use a data-attr flag if you need to avoid double-binding)
 */
window.ProductInit = (function () {
  const handlers = new Set();
  let scheduled = false;

  function runAll(reason) {
    handlers.forEach(function (fn) {
      try { fn(reason); }
      catch (err) { console.error('[ProductInit]', fn.name || 'handler', err); }
    });
  }

  function scheduleRun(reason) {
    if (scheduled) return;
    scheduled = true;
    // microtask → runs after the synchronous product:rerender swap completes
    queueMicrotask(function () {
      scheduled = false;
      runAll(reason);
    });
  }

  // Re-run after every variant swap. variant:changed bubbles to document.
  document.addEventListener('variant:changed', function () { scheduleRun('variant:changed'); });

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runAll('DOMContentLoaded'); });
  } else {
    runAll('initial');
  }

  return {
    register: function (fn) {
      handlers.add(fn);
      // If registered after initial load, run once immediately so late-loaded
      // scripts don't miss the first pass.
      if (document.readyState !== 'loading') {
        try { fn('late-register'); } catch (err) { console.error(err); }
      }
      return fn;
    },
    trigger: function (reason) { scheduleRun(reason || 'manual'); },
  };
})();

/* -------------------------------------------------------------------------- */
/* Register handlers below. Each one runs on load + after every variant swap. */
/* -------------------------------------------------------------------------- */

// Size option label — show full variant title for size swatches
ProductInit.register(function updateSizeOptionLabels() {
  document.querySelectorAll('variant-picker').forEach(function (picker) {
    picker.querySelectorAll('.product-form__option').forEach(function (option) {
      const optionName = option.querySelector('.product-form__option-name');
      if (!optionName) return;

      const selectedValueSpan = optionName.querySelector('.product-form__selected-value');
      if (!selectedValueSpan) return;

      const isSizeOption = option.classList.contains('product-form__option--size');
      const blockSwatchList = option.querySelector('.block-swatch-list');
      if (!blockSwatchList || !isSizeOption) return;

      const checkedInput = option.querySelector('.block-swatch__radio:checked');
      if (!checkedInput) return;

      const swatch = checkedInput.closest('.block-swatch');
      const fullTitle =
        checkedInput.getAttribute('data-full-value') ||
        swatch?.querySelector('label, a')?.getAttribute('title') ||
        swatch?.querySelector('label, a')?.getAttribute('data-full-value') ||
        selectedValueSpan.textContent;

      if (fullTitle) selectedValueSpan.textContent = fullTitle;
    });
  });
});
